import { FC, PropsWithChildren, useState } from 'react';

import { useDisclosure } from '@bonusly/design-system';

import { BookmarkModal } from '../../components/bookmark-modal/bookmark-modal';
import { BookmarkDTO } from '../../components/bookmark/lib/entities';
import { BookmarkContextProvider, BookmarkContextValue } from '../../context';

type PropsFromContext = Pick<BookmarkContextValue, 'referenceType' | 'referenceId' | 'referenceText' | 'bookmark'>;

export interface BookmarkProps extends PropsFromContext, PropsWithChildren {}

export const Bookmark: FC<BookmarkProps> = ({ referenceId, referenceType, referenceText, children, bookmark: initialBookmark }) => {
	const bookmarkModal = useDisclosure();
	const [bookmark, setBookmark] = useState<BookmarkDTO | undefined>(initialBookmark);
	const [labelsIds, setLabelsIds] = useState<Array<string> | undefined>(initialBookmark?.labels.map((label) => label.id));
	const [notes, setNotes] = useState<string | undefined>(initialBookmark?.notes);
	const [suggestions, setSuggestions] = useState<Array<string>>();

	return (
		<BookmarkContextProvider
			value={{
				labelsIds,
				setLabelsIds,
				notes,
				setNotes,
				referenceId,
				referenceType,
				bookmark,
				setBookmark,
				onCloseModal: bookmarkModal.onClose,
				isModalOpen: bookmarkModal.isOpen,
				onOpenModal: bookmarkModal.onOpen,
				referenceText,
				suggestions,
				setSuggestions,
			}}
		>
			{children}
			<BookmarkModal />
		</BookmarkContextProvider>
	);
};

Bookmark.displayName = 'Bookmark';
